const translations = {
    ADD_NEW_ROLE: "הוסף תפקיד חדש",
    ROLE_NAME: "שם התפקיד",
    SELECT_PAGES: "בחר עמודים",
    NO_OPTIONS: "אין אפשרויות",
    ADD: "הוסף",
    CANCEL: "ביטול",
    SELECT_AT_LEAST_ONE_PERMISSION: "יש לבחור לפחות הרשאה אחת",
  };
  
  export default translations;